import { Cliente } from "src/app/models/cliente";
import { Model } from "./model";
import { Brigadista } from "src/app/models/brigadista";
import { Residente } from "src/app/models/residente";
import { Pessoa } from "./pessoa";
import { Edificacao } from "src/app/models/edificacao";
import { Estabelecimento } from "src/app/models/estabelecimento";
import { Andar } from "src/app/models/andar";
import { Perfil } from "src/app/models/perfil";
import { Turno } from "src/app/models/turno";
import { Equipe } from "src/app/models/equipe";
import { Escala } from "src/app/models/escala";
import { Certificado } from "src/app/models/certificado";
import { UsuarioMeta } from "src/app/models/usuario-meta";

export class Usuario extends Model{
    private _cliente?: Cliente;
    private _configuracao: any;
    private _brigadista?: Brigadista;
    private _permissoes?: any;

    pessoa!: Pessoa;
    residente?: Residente;
    email!: string;
    admin!: boolean;
    master!: boolean;
    bombeiro!: boolean;
    ativo!: boolean;
    login_externo!: boolean;
    appkey?: string;
    webkey?: string;
    imagem?: string;
    avatar?: string;
    assinatura?: string;
    auth_config?: UsuarioAuthConfig;

    qtd_mensagens!: number;
    qtd_notificacoes!: number;
    edificacoes?: Edificacao[];
    perfil?: Perfil;
    // equipe?: {nome: string};
    funcao_id?: number;
    turnos?: Turno[];
    equipes?: Equipe[];
    escalas?: Escala[];
    certificados?: Certificado[];
    metas?: UsuarioMeta[];
    meta_realizada?: MetaRealizada;
    media?: number;
    pivot?: any;

    get isCliente(){
        return this._cliente ? true : false;
    }

    get isBrigadista(){
        return this.brigadista ? true : false;
    }

    get isResidente(){
        return this.residente ? true : false;
    }

    get cliente(): Cliente | undefined{
        return this._cliente ? this._cliente : (this.brigadista ? (this.brigadista.andar ? this.brigadista.andar.edificacao?.estabelecimento?.cliente : this.brigadista.turno ? this.brigadista.turno.edificacao?.estabelecimento?.cliente : this.brigadista.edificacao?.estabelecimento?.cliente) : this.residente?.andar?.edificacao?.estabelecimento?.cliente);
    }

    set cliente(c){
        this._cliente = c ? new Cliente(c) : undefined;
    }

    get andar(): Andar | undefined{
        return this.brigadista || this.residente ? (this.brigadista?.andar || this.residente?.andar) : undefined;
    }

    get edificacao(): Edificacao | undefined{
        return this._cliente ? this._cliente.edificacao : (this.brigadista ? this.brigadista.edificacao : this.residente?.andar.edificacao);
    }

    get estabelecimento(): Estabelecimento | undefined{
        return this._cliente ? this._cliente.estabelecimento : (this.brigadista ? this.brigadista.edificacao?.estabelecimento : this.residente?.andar.edificacao.estabelecimento);
    }

    get configuracao(){
        let padrao: any = {
            app:{
                vibrar : true,
                som : true,
                audio : 'fogo1.mp3',
                edit_img: true,
                connections: [
                    // {text: 'Desconhecido (não recomendado)', name: Connection.UNKNOWN || 'unknown', value: true},
                    // {text: 'Rede Celular (não recomendado)', name: Connection.CELL || 'cellular', value: false},
                    // {text: '2G (não recomendado)', name: Connection.CELL_2G || '2g', value: false},
                    // {text: '3G (não recomendado)', name: Connection.CELL_3G || '3g', value: false},
                    // {text: '4G', name: Connection.CELL_4G || '4g', value: true},
                    // {text: 'Wifi', name: Connection.WIFI || 'wifi', value: true}
                    {text: 'Desconhecido', name: 'unknown', value: true},
                    {text: 'Dados Móveis', name: 'cellular', value: true},
                    {text: 'Wifi', name: 'wifi', value: true},
                ],
            },
            notificacao: {
                "ATA":true,
                "SINISTRO":true,
                "MENSAGEM":true,
                "PENDENCIA":true,
                "ATIVIDADE":true,
                "TREINAMENTO":true,
                "EQUIPAMENTO":true,
                "MEDIDOR_IOT":true,
                "CERTIFICADO":true,
                "DOCUMENTO": true,
                "NOTIFICACAO":true
            }
        };

        return Object.assign({}, padrao, (this._configuracao || {}));
    }

    set configuracao(c: any){
        this._configuracao = c;
    }

    set brigadista(b){
        this._brigadista = b ? new Brigadista(b) : undefined;
    }

    get brigadista(){
        return this._brigadista;
    }

    get permissoes(){
        if(this.perfil)
            return {};
        return this._permissoes || {};
    }

    set permissoes(p: any){
        this._permissoes = p;
    }

    public permissao(identificador: string, method: 'view' | 'viewAny' | 'create' | 'update' | 'delete' = 'viewAny') : boolean{
        if(this.perfil){
            let op = this.perfil.operacoes.find(o => o.identificador == identificador);
            if(op)
                return op.pivot.total || op.pivot[method];
        }

        return false;
    }

    public moduloHabilitado(identificador: string): boolean{
        if(this.admin)
            return true;

        const cliente = this.cliente;
        if(!cliente)
            return false;

        if(cliente.modular)
            return !!this.edificacao?.modulos?.find(m => m.identificador === identificador);

        return !!cliente.conf?.[identificador];
    }

    public podeInverterEquipamentoInspecao(): boolean{
        return this.podeExecutarAcaoEquipamentoInspecao(
            'desativar_inversao_equipamento_inspecao',
            'desativar_troca_equipamento_inspecao'
        );
    }

    public podeDefinirPosicaoVaziaInspecao(): boolean{
        return this.podeExecutarAcaoEquipamentoInspecao(
            'desativar_posicao_vazia_inspecao',
            'desativar_troca_equipamento_inspecao'
        );
    }

    public podeLancarEquipamentoEstoqueInspecao(): boolean{
        return this.podeExecutarAcaoEquipamentoInspecao('desativar_lancar_estoque_inspecao');
    }

    private podeExecutarAcaoEquipamentoInspecao(chave: string, chaveLegada?: string): boolean{
        const configuracao = this._configuracao || {};
        for(const chaveUsuario of [chave, chaveLegada].filter(Boolean) as string[]){
            if(Object.prototype.hasOwnProperty.call(configuracao, chaveUsuario)
                && configuracao[chaveUsuario] !== null
                && configuracao[chaveUsuario] !== ''){
                return !this.configuracaoAtiva(configuracao[chaveUsuario]);
            }
        }

        const confEstabelecimento: any = this.estabelecimento?.conf || {};
        for(const chaveEstabelecimento of [chave, chaveLegada].filter(Boolean) as string[]){
            if(Object.prototype.hasOwnProperty.call(confEstabelecimento, chaveEstabelecimento)
                && confEstabelecimento[chaveEstabelecimento] !== null
                && confEstabelecimento[chaveEstabelecimento] !== ''){
                return !this.configuracaoAtiva(confEstabelecimento[chaveEstabelecimento]);
            }
        }

        return true;
    }

    public podeUsarGaleria(modulo: string): boolean{
        const configuracao = this._configuracao || {};
        const regraUsuario = configuracao.galeria?.[modulo];

        if(regraUsuario === 'permitir')
            return true;
        if(regraUsuario === 'bloquear')
            return false;

        const galeriaEstabelecimento = this.estabelecimento?.conf?.galeria;
        if(galeriaEstabelecimento && Object.prototype.hasOwnProperty.call(galeriaEstabelecimento, modulo))
            return this.configuracaoAtiva(galeriaEstabelecimento[modulo]);

        return this.configuracaoAtiva(this.estabelecimento?.conf?.enable_galeria);
    }

    private configuracaoAtiva(valor: any): boolean{
        return valor === true || valor === 1 || valor === '1' || valor === 'true';
    }
}

export interface MetaRealizada{
    atividades: number;
    pendencias: number;
}

export interface UsuarioAuthConfig{
    duplo_fator_app?: boolean;
    duplo_fator_web?: boolean;
    app_token_curto?: boolean;
    app_token_expira_horas?: number;
    app_biometria_desbloqueio?: boolean;
    app_manter_token_com_biometria?: boolean;
}
